// extracted by mini-css-extract-plugin
export default {"video_and_thumbnail":"VideoTumbnail_video_and_thumbnail__IIuxF"};